import {Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class SnackService {

  constructor(private snackBar: MatSnackBar) { }

  public success(message: string): void {
    this.snackBar.open(message, 'Ok', {
      panelClass: ['mat-background-light', 'color-dark', 'border-warn'],
      duration: 4000
    });
  }

  public info(message: string): void {
    this.snackBar.open(message, 'Ok', {
      panelClass: ['mat-background-light', 'color-dark', 'border-warn'],
      duration: 4000
    });
  }

  public error(message: string): void {
    this.snackBar.open(message, 'Ok', {
      panelClass: ['mat-background-light', 'color-dark', 'border-warn', 'border'],
    });
  }



  public dismiss(): void {
    this.snackBar.dismiss();
  }

  afterDismissed() {
    this.snackBar.dismiss();
  }

}
